import CloseIcon from '@mui/icons-material/Close';
import { Alert, IconButton, Snackbar } from '@mui/material';
import React, { Fragment } from 'react';


export default function SuccessMessageComponent({ message, handleClose, show }) {
    return (
        <Snackbar
            open={show}
            autoHideDuration={4000}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            action={
                <IconButton
                    aria-label="close"
                    color="inherit"
                    sx={{ p: 0.5 }}
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton>
            }
        >
            <Alert severity="success" sx={{ width: "100%" }} onClose={handleClose}>
                {message}
            </Alert>
        </Snackbar>
    );
}

